import React, { useEffect } from "react";
import Background_Member2 from "../../assets/images/inner-banner.jpg";
import { Link } from "react-router-dom";

import EngagementOfConsultant from "../../assets/pdf/recruitment/Engagement of consultant.pdf";
import EngagementOfVariousPost from "../../assets/pdf/recruitment/Engagement of various post.pdf";

const Recruitment = ({ recruitmentDataProp }) => {
  document.title = "Recruitment | Gujarat State Allied and Healthcare Council";
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Array of recruitment data: { title, link, lastDate }
  const recruitmentData = recruitmentDataProp || [
    {
      title:
        "Engagement of various staff in Gujarat State Allied and Healthcare Council (GSAHC) on Contract Basis dated 21/09/2026",
      link: EngagementOfVariousPost,
      lastDate: "09-10-2026",
    },
    {
      title:
        "Engagement of Consultant in Gujarat State Allied and Healthcare Council (GSAHC) on Contract Basis dated 21/09/2026",
      link: EngagementOfConsultant,
      lastDate: "09-10-2026",
    },
  ];

  return (
    <div className="wrappermain">
      {/*Recruitment Banner Section */}
      <div
        className="banner-image wrappermain"
        style={{
          backgroundImage: "url(" + Background_Member2 + ")",
          backgroundPosition: "right",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          padding: "25px 0",
        }}
      >
        <div className="banner-inner-breadcrumb">
          <div className="container">
            <nav aria-label="breadcrumb">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to={"/"}>Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Recruitment
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>

      {/*Recruitment Table Section */}
      <div className="container my-5">
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Recruitment</th>
                <th>Last Date</th>
              </tr>
            </thead>
            <tbody>
              {recruitmentData.length ? (
                recruitmentData.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <a
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="custom-link"
                      >
                        {item.title}
                      </a>
                      <small
                        className="ms-2 px-2 py-0 fw-bold text-uppercase"
                        style={{
                          color: "#fff",
                          backgroundColor: "#dc3545",
                          border: "1.5px solid #dc3545",
                          borderRadius: "4px",
                          fontSize: "0.7rem",
                          whiteSpace: "nowrap",
                        }}
                      >
                        New
                      </small>
                    </td>
                    <td>{item.lastDate || "-"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={2} className="text-center">
                    No recruitment available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Recruitment;
